import { CARE_PARTNER_TYPES } from '../../../constants/carePartnerTypes';

export const PARTNER_TYPE_SHORT = {
  [CARE_PARTNER_TYPES.HOSPITAL.id]: 'Hôpital',
  [CARE_PARTNER_TYPES.OPHTHALMOLOGY.id]: 'Ophtalmo',
  [CARE_PARTNER_TYPES.PEDIATRICS.id]: 'Pédiatrie',
  [CARE_PARTNER_TYPES.OPTICAL.id]: 'Optique',
  [CARE_PARTNER_TYPES.OTHER.id]: 'Autre'
};

const TYPE_PILL_MODIFIER = {
  [CARE_PARTNER_TYPES.HOSPITAL.id]: 'hospital',
  [CARE_PARTNER_TYPES.OPHTHALMOLOGY.id]: 'ophthalmology',
  [CARE_PARTNER_TYPES.PEDIATRICS.id]: 'pediatrics',
  [CARE_PARTNER_TYPES.OPTICAL.id]: 'optical',
  [CARE_PARTNER_TYPES.OTHER.id]: 'other'
};

export function getPartnerTypePillProps(partnerType) {
  const modifier = TYPE_PILL_MODIFIER[partnerType] || 'other';
  return {
    label: PARTNER_TYPE_SHORT[partnerType] || partnerType,
    className: `hd-partner-type-pill hd-partner-list__type hd-partner-type-pill--${modifier}`
  };
}

/**
 * Ligne secondaire : contact et adresse (le type est toujours affiché en badge).
 */
export function buildPartnerListSecondaryLine(item) {
  const parts = [];

  if (item.address?.trim()) {
    parts.push(item.address.trim());
  }

  if (item.phone?.trim()) {
    parts.push(item.phone.trim());
  }

  if (item.email?.trim()) {
    parts.push(item.email.trim());
  }

  if (item.notes?.trim()) {
    parts.push(item.notes.trim());
  }

  return parts.join(' · ');
}
